import { useReduxState } from 'hooks';
import { PageCustomContentContainer, PagePlain } from 'components/page';
import { Link } from 'components/common';
import { RegisterForm } from '.';

const Register = () => {
  const {
    language,
    messages,
    serverConfig: {
      registerCustomContent,
      registerCustomContentBeside,
      registerCustomContentLocales
    },
    theme
  } = useReduxState();

  const customContent =
    registerCustomContentLocales?.[language] || registerCustomContent;

  return (
    <PagePlain
      padding={0}
      title={messages.authRegister}
      width={
        registerCustomContentBeside &&
        (registerCustomContent || registerCustomContentLocales?.[language])
          ? 'wide'
          : 'narrow'
      }
    >
      <PageCustomContentContainer
        customContent={customContent}
        customContentBeside={registerCustomContentBeside}
      >
        <RegisterForm />

        <div className="login">
          <Link href="/login" text={messages.authBackToLogin} />

          <style jsx>{`
            .login {
              font-size: 1.4rem;
              margin-top: 15px;
              text-align: center;
            }
          `}</style>
        </div>
      </PageCustomContentContainer>
    </PagePlain>
  );
};

export default Register;
